import { render, staticRenderFns } from "./promotion_rule.vue?vue&type=template&id=5b1b911e&scoped=true"
import script from "./promotion_rule.vue?vue&type=script&lang=js"
export * from "./promotion_rule.vue?vue&type=script&lang=js"
import style0 from "./promotion_rule.vue?vue&type=style&index=0&id=5b1b911e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b911e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1b911e')) {
      api.createRecord('5b1b911e', component.options)
    } else {
      api.reload('5b1b911e', component.options)
    }
    module.hot.accept("./promotion_rule.vue?vue&type=template&id=5b1b911e&scoped=true", function () {
      api.rerender('5b1b911e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_policy/form/promotion_rule/promotion_rule.vue"
export default component.exports